import React from 'react';
import { StreamSearchContextValueType } from './types';

export const StreamSearchContext = React.createContext<StreamSearchContextValueType>(
  {} as StreamSearchContextValueType
);
